import { Howl } from "howler";

export default class Track {
  constructor({
    track,
    onload = null,
    onplay = null,
    onend = null,
    onpause = null,
    onlistened = null
  }) {
    this._howl = new Howl({
      src: [track.file],
      html5: true,
      autoplay: false,
      preload: "auto",
      autoSuspend: false,
      autoUnlock: true
    });

    this.name = track.name;
    this.id = track.id;
    this.timecode = 0;
    this.subscribers = {
      listened: []
    };

    this.onload(onload);
    this.onplay(onplay);
    this.onend(onend);
    this.onpause(onpause);
    this.onlistened(onlistened);
  }
  load() {
    this._howl.load();
  }
  unload() {
    this._howl.unload();
  }
  play() {
    if (!this.playing) {
      this._howl.play();
      this.timecode = 0;
    }
  }
  pause() {
    this._howl.pause();
  }
  stop() {
    this._howl.stop();
    this.unload();
    this.listened();
  }
  listened() {
    if (this.timecode > this.duration * 0.95) {
      this.timecode = 0;
      this.subscribers.listened.forEach(fn => fn());
    }
  }
  seek(seek) {
    if (this._howl._sounds.length) {
      if (!isNaN(seek)) {
        this._howl.seek(seek);
      } else {
        const time = this._howl.seek();
        const isObject = typeof time === "object";

        return isObject ? 0 : time;
      }
    }
  }
  onload(fn) {
    if (fn) {
      this._howl.on("load", () => fn(this));
    }
  }
  onplay(fn) {
    if (fn) {
      this._howl.on("play", () => fn(this));
    }
  }
  onpause(fn) {
    if (fn) {
      this._howl.on("pause", () => fn(this));
    }
  }
  onend(fn) {
    if (fn) {
      this._howl.on("end", () => fn(this));
    }
  }
  onstop(fn) {
    if (fn) {
      this._howl.on("stop", () => fn(this));
    }
  }
  onlistened(fn) {
    if (fn) {
      this.subscribers.listened.push(fn);
    }
  }
  get duration() {
    return this._howl.duration();
  }
  get playing() {
    return this._howl.playing();
  }

  get node() {
    try {
      return this._howl._sounds[0]._node;
    } catch (error) {
      return null;
    }
  }
}
